import configs from 'configs';
import { authHeaders } from 'functions/authHeader';
import { GA_UPLOAD_CHAT_EVENTS } from 'modules/ga/generalEvents';
import app from 'new-ui/app';

const apiUrl = configs.beApiUrl;

/**
 * Sends a message to the chat API and returns the response.
 *
 * @param {string} prompt - The prompt for the message
 * @param {string} userWixId - The user's Wix ID
 * @param {string} indication - The indication for the message
 * @return {Promise<Object>} The response from the chat API
 */
// eslint-disable-next-line consistent-return
export const sendMessage = async (prompt, userWixId, indication, extractedInfo) => {
  const payload = JSON.stringify({
    prompt,
    userWixId,
    indication,
    extractedInfo,
  });
  app.sendGoogleAnalyticsEvent(GA_UPLOAD_CHAT_EVENTS.UPLOAD_CHAT_USER_SEND_MESSAGE_TO_CHAT, 'user send msg to upload chat');
  try {
    const response = await fetch(`${apiUrl}/uploadChat/chatUploadSession`, {
      method: 'POST',
      headers: await authHeaders(),
      body: payload,
    });

    if (!response.ok) {
      throw new Error(`Error sending message: ${response.statusText}`);
    }

    const ans = await response.json();
    return ans;
  } catch (error) {
    console.error('Error sending message:', error);
  }
};
